module.exports = __webpack_public_path__ + "img/matthias.500f3fc5.jpg";